import React from 'react'
import MaterialSymbol from '../material-symbol'

const MoreHoriz = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="more_horiz" {...props} />
))

MoreHoriz.displayName = 'MoreHoriz'

export default MoreHoriz
